import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { Button } from 'src/shared/components/Button';
import { color, layout, mediaQueries } from 'src/shared/styles/variables';

interface StepButtonsContainerProps {
    inStep?: boolean;
}

const StepButtonsContainer = styled('div')((props: StepButtonsContainerProps) => ({
    backgroundColor: color.white,
    borderTop: `1px solid ${color.gallery}`,
    marginTop: props.inStep ? '1.75rem' : 0,
}));

interface StepButtonsWrapperProps {
    noHorizontalPadding?: boolean;
}

const StepButtonsWrapper = styled('div')<StepButtonsWrapperProps>(({ noHorizontalPadding }) => ({
    maxWidth: layout.containerSmallerWidth,
    margin: '0 auto',
    padding: noHorizontalPadding ? '0.88rem 0.00rem' : '0.88rem 1.75rem',
    display: 'flex',
    justifyContent: 'space-between',
    [mediaQueries.sm]: {
        flexDirection: 'column',
        '& > *:first-child': {
            marginBottom: '0.88rem',
        },
        '& > *:last-child': {
            marginLeft: 0,
        },
    },
}));

export interface StepButtonsProps {
    goToPreviousStep: () => void;
    goToNextStep: () => void;
}

interface Props extends WithTranslation {
    onPreviousClick: () => void;
    onNextClick: () => void;
    hasNextStep?: boolean;
    nextDisabled?: boolean;
    nextDisabledTooltip?: string;
    inStep?: boolean;
    noHorizontalPadding?: boolean;
}

export const StepButtons = withTranslation()((props: Props) => (
    <StepButtonsContainer inStep={props.inStep}>
        <StepButtonsWrapper noHorizontalPadding={props.noHorizontalPadding}>
            <Button type="cancel" onClick={props.onPreviousClick}>
                {props.t('common.back')}
            </Button>
            <Button
                disabled={props.nextDisabled}
                disabledTooltip={props.nextDisabledTooltip}
                onClick={props.onNextClick}
            >
                {props.t(`common.${props.hasNextStep ? 'continue' : 'takeMeHome'}`)}
            </Button>
        </StepButtonsWrapper>
    </StepButtonsContainer>
));
